/**
 * Component Entry
 *
 */

import Tooltip from './Tooltip'
export default Tooltip
export * from './Tooltip'
